import React from 'react'
import styled from 'styled-components'

import { Button } from '@/UIkit/Button'

import { ReactComponent as HouseIcon } from '../../../../assets/svgs/green-house-checkmark-toggle.svg'
import { InformationSection } from '../InformationSection'

import type { SuccessfulOperationProps } from './types'

const Description = styled.div`
  margin-bottom: 20px;
`

export const SuccessfulOperation = ({
  onGoBack,
  title,
  description,
  buttonText,
}: SuccessfulOperationProps) => (
  <InformationSection
    iconProps={{ iconComponent: HouseIcon, width: 175, height: 150 }}
    title={title}
  >
    <Description>{description}</Description>
    <Button onClick={onGoBack} isFullWidth>
      {buttonText}
    </Button>
  </InformationSection>
)
